module.exports = __webpack_public_path__ + "static/media/about-3.e76b9825.jpg";